// extracted by mini-css-extract-plugin
export default {"go":"PuntosGo_go__epAbI","logo":"PuntosGo_logo__cBzLE","text":"PuntosGo_text__Qs02t","star":"PuntosGo_star__E4rLl"};